import { useFullScreenState } from './FullScreenContext'

export const HideOnFullScreen = ({ children }) => {
  const { isFullScreen } = useFullScreenState()
  if (!!isFullScreen) return false

  return children
}

export const ShowOnFullScreen = ({ children }) => {
  const { isFullScreen } = useFullScreenState()
  if (!isFullScreen) return false

  return children
}
